"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var antd_1 = require("antd");
var FontAwesome_1 = require("../../../../../../shared/components/icons/FontAwesome");
var BrandAdminsAccessList_1 = require("./access/admins/BrandAdminsAccessList");
var BrandOperationsAccess = /** @class */ (function (_super) {
    __extends(BrandOperationsAccess, _super);
    // private readonly tab_frontends_ftp_access = "ftp.access.frontends";
    function BrandOperationsAccess(props) {
        var _this = _super.call(this, props) || this;
        _this.tab_admins_access = "access.admins";
        return _this;
    }
    BrandOperationsAccess.prototype.componentWillMount = function () {
        this.setState({
        // FrontendFTPAccessMode: "LIST",
        // FrontendFTPRecord: null
        });
        this.props.state.setExtBreadCrumbPath(["Доступ к брендам"]);
    };
    BrandOperationsAccess.prototype.onGoBackToTopPageClick = function () {
        if (this.props.onGoBackClick) {
            this.props.onGoBackClick();
        }
    };
    BrandOperationsAccess.prototype.getBrandAdminAccessRenderObject = function () {
        return (React.createElement(BrandAdminsAccessList_1.default, { state: this.props.state, data: this.props.dataAccess, dialog: this.props.dialog, record: this.props.record, onGoBackClick: this.onGoBackToTopPageClick.bind(this) }));
    };
    BrandOperationsAccess.prototype.render = function () {
        return (React.createElement("div", null,
            React.createElement(antd_1.Tabs, { defaultActiveKey: this.tab_admins_access },
                React.createElement(antd_1.Tabs.TabPane, { tab: React.createElement("span", { style: { width: 200, minWidth: 200 } },
                        React.createElement(FontAwesome_1.FA, { left: true, icon: "user-lock" }),
                        "\u0414\u043E\u0441\u0442\u0443\u043F \u0430\u0434\u043C\u0438\u043D\u0438\u0441\u0442\u0440\u0430\u0442\u043E\u0440\u043E\u0432"), key: this.tab_admins_access }, this.getBrandAdminAccessRenderObject()))));
    };
    return BrandOperationsAccess;
}(React.Component));
exports.default = BrandOperationsAccess;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/BrandOperationsAccess.tsx
// module id = 1757
// module chunks = 0